const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Workshops Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Workshops', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/workshops/:subresource/:subsubresource/:instanceId/:action', null, {
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    overviewStats: {params: {subresource: 'overview-stats'}, method: 'GET', isArray: false},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    report: {params: {subresource: 'report'}, method: 'POST', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    duplicate: {params: {subresource: '', action: 'duplicate'}, method: 'POST', isArray: false},
    fullDelete: {params: {subresource: ''}, method: 'DELETE', isArray: false},
    updateRegistrationStatuses: {params: {subresource: '', subsubresource: 'instance', instanceId: '', action: 'registration-statuses'}, method: 'POST', isArray: false}
  });
}]);
